import { useSuspenseQueries } from "@tanstack/react-query";
import { getMeTenantPermissionsQueryOptions } from "api/User/queryOptions";
import { PermissionEnum } from "types/enums";

import { useUser } from "./useUser";

export function usePermissionInAnyTenant(permission: PermissionEnum): boolean {
    const tenants = useUser().getAuthenticatedUser()?.tenants ?? [];
    const permissionQueries = useSuspenseQueries({
        queries: tenants.map((tenant) => getMeTenantPermissionsQueryOptions(tenant.slug_name)),
    });

    return permissionQueries.some(({ data }) =>
        data.permissions.some((tenantPermission) => tenantPermission.name === permission)
    );
}
